import {t} from '@eitje/bridge'

export const getTableHeaderFieldName = ({name, recordType, field}) => {
	return t(`table.${name}.headers.${field}`, t(`records.${recordType}.fields.${field}`, t(`records.default.fields.${field}`)))
}

export const getSelectedRows = tableData => {
	const rows = tableData.getRowModel().flatRows
	const selectedRows = _.uniqBy(
		rows.filter(row => row.getIsSelected() && !row.getIsGrouped()),
		'id',
	)
	return selectedRows
}
